let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6NWpq")).then(() => parcelRequire('aTR9Q'));